import { createContext } from "react";
import { useState, useEffect } from 'react';

import jitlova from './img/categori/11.jpg';
import commerce from './img/categori/12.jpg';

//житлова нерухомість - 11
//test1
import test1 from './img/jitlo/test/1.jpg';
import test2 from './img/jitlo/test/2.jpg';
import test3 from './img/jitlo/test/3.jpg';
import test4 from './img/jitlo/test/4.jpg';
import plan_test from './img/jitlo/test/plan.jpg';
import outside1 from './img/jitlo/test/outside1.jpg';
import outside2 from './img/jitlo/test/outside2.jpg';
//test2
import test_21 from './img/jitlo/test2/1.jpg';
import test_22 from './img/jitlo/test2/2.jpg';
import test_23 from './img/jitlo/test2/3.jpg';
import test_24 from './img/jitlo/test2/4.jpg';
import plan_test2 from './img/jitlo/test2/plan.jpg';
import outside21 from './img/jitlo/test/outside1.jpg';
import outside22 from './img/jitlo/test/outside2.jpg';
import marker_gost from './img/jitlo/test2/marker_gost.mp4';

//Хрещатик 15
import hrechatik_1 from './img/jitlo/hrechatik_15/1.jpg';
import hrechatik_2 from './img/jitlo/hrechatik_15/2.jpg';
import hrechatik_3 from './img/jitlo/hrechatik_15/3.jpg';
import hrechatik_4 from './img/jitlo/hrechatik_15/4.jpg';
import hrechatik_5 from './img/jitlo/hrechatik_15/5.jpg';
import hrechatik_6 from './img/jitlo/hrechatik_15/6.jpg';
import hrechatik_7 from './img/jitlo/hrechatik_15/7.jpg';
import hrechatik_8 from './img/jitlo/hrechatik_15/8.jpg';
import hrechatik_9 from './img/jitlo/hrechatik_15/9.jpg';
import hrechatik_10 from './img/jitlo/hrechatik_15/10.jpg';
import hrechatik_11 from './img/jitlo/hrechatik_15/11.jpg';
import hrechatik_12 from './img/jitlo/hrechatik_15/12.jpg';
import hrechatik_13 from './img/jitlo/hrechatik_15/13.jpg';
import hrechatik_14 from './img/jitlo/hrechatik_15/14.jpg';
//план Хрещатик 15
import plan_hrechatik from './img/jitlo/hrechatik_15/plan.png';
import hrechatik_marker1 from './img/jitlo/hrechatik_15/marker_1.mp4';
import hrechatik_marker2 from './img/jitlo/hrechatik_15/marker_2.mp4';
import hrechatik_marker3 from './img/jitlo/hrechatik_15/marker_3.mp4';
import hrechatik_marker4 from './img/jitlo/hrechatik_15/marker_4.mp4';
import hrechatik_marker5 from './img/jitlo/hrechatik_15/marker_5.mp4';
import hrechatik_marker6 from './img/jitlo/hrechatik_15/marker_6.jpg';
//будівля хрещатик 15
import hrechatik_bild1 from './img/jitlo/hrechatik_15/bild_krechatik_1.jpg';
import hrechatik_bild2 from './img/jitlo/hrechatik_15/bild_krechatik_2.jpg';
import hrechatik_bild3 from './img/jitlo/hrechatik_15/bild_krechatik_3.jpg';
import hrechatik_bild4 from './img/jitlo/hrechatik_15/bild_krechatik_4.jpg';
  




//комерційна нерухомість - 12
import start_1 from './img/comercia/start/1.png';
import start_2 from './img/comercia/start/2.jpg';



import bild_start_1 from './img/comercia/start/outside1.png';
import bild_start_2 from './img/comercia/start/outside2.png';
import bild_start_3 from './img/comercia/start/outside3.jpg';
import bild_start_4 from './img/comercia/start/outside4.jpg';
import bild_start_5 from './img/comercia/start/outside5.jpg';
import plan_start from './img/comercia/start/plan_start.png';

import marker_1et from './img/comercia/start/marker_1et.mp4';


export const FsrContext = createContext(null);
FsrContext.displayName = "FsrContext";

const AppContext = ({ children }) => {
const kategoris = [
  {
    id: 11,
    name: "Житлова нерухомість",
    foto: jitlova,
    lists: [
      {
        id: 1128,
        rentsal: "Продаж",
        typeRealt: "Житло",
        kimnat: 3,
        vlasnik: "фізична особа ",
        propisan: "немає ",
        name: "вулиця Пономарьова 26",
        foto: [test_21, test_22, test_23, test_24],
        repair: "з ремонтом",
        interv: null,
        currency: "$",
        descrip: [
          "Простора сучасна квартира, облаштована меблями і побутовою технікою. Три окремі кімнати,два санвузла, два балкона. Квартира не вуглова.Є відео квартири. Перегляд по домовленості.",
        ],
        price: 150000,
        priceLast: 0,
        flor: "7 з 24",
        area: 107,
        areaAll: "107 / 60 / 15",
        hight: "2.7 м",
        priceTime: 1500,
        priceTimeGrn: 70000,
        florTime: 2,
        areaTime: 3,
        status: true,
        vip: false,
        avtoJivlenElevator: "Є",
        avtoJivlenWather: "Є",
        electricity: "10 кВт ",
        planImage: plan_test2,
        markers: [
          {
            id: 1,
            title: "Кухня",
            x: 35,
            y: 42,
            media: [{ type: "video", src: marker_gost }],
          },
          {
            id: 2,
            title: "Вікно 1",
            x: 18,
            y: 14,
            media: [{ type: "image", src: outside1 }],
          },
        ],
        videoUrl: "https://www.youtube.com/shorts/LQAvF2QwTJU",
        fotoBild: [outside1, outside2, test3, test4],
        allApart: "212",
        allFlors: "24",
        typeBild: "спецпроект",
        security: "Домофон, Консьерж",
        material: "цегляна",
        heating: "централізоване опалення",
        yearBuild: "2017",
        houseWifi: "Lanet, Volia, Kyivstar",
        shelter: "3 хв. пішки",
        water: "вода є",
        tax5: false,
        war5: false,
        mit1: false,
        pens1: true,
        nota: 100,
        komis: 2,
        lichilHvp: "20.11.2027",
        lichilGvp: "02.03.2028",
        lichilWarm: "",

        title: "ЖК Старт",
        address: "Київ, ...",
        center: [50.457839, 30.481385],
        bearing: 0,
        buildingPolygon: [
          [50.458143, 30.481377],
          [50.45495, 30.46855],
          [50.45462, 30.46888],
          [50.45439, 30.46864],
        ],
        location: "https://maps.app.goo.gl/Mo73CUnrpnWvvo286",
      },

      {
        id: 1129,
        rentsal: "Продаж",
        typeRealt: "Житло",
        kimnat: 1,
        vlasnik: "",
        // colorvlasnik:'0da514',
        name: "вул. Велика Васильківська 114",
        foto: [test1, test2, test3, test4],
        repair: "з ремонтом",
        fotoBild: [outside21, outside22, test3, test4],
        interv: null,
        currency: "$",
        descrip: [
          "Простора сучасна квартира, облаштована меблями і побутовою технікою. Три окремі кімнати,два санвузла, два балкона. Квартира не вуглова.Є відео квартири. Перегляд по домовленості.",
        ],
        price: 65000,
        flor: "7 з 7",
        area: 28.75,
        areaAll: "28.75 / 14.4 / 4.1",
        hight: "2.7 м",
        priceTime: 1500,
        priceTimeGrn: 70000,
        florTime: 2,
        areaTime: 3,
        status: true,
        vip: false,
        avtoJivlenElevator: "Немає",
        avtoJivlenWather: "Є від міста",
        electricity: "6 кВт ",
        planImage: plan_test,
        markers: [
          {
            id: 1,
            title: "Кухня",
            x: 35,
            y: 42,
            media: [{ type: "video", src: marker_gost }],
          },
          {
            id: 2,
            title: "Вікно 1",
            x: 18,
            y: 14,
            media: [{ type: "image", src: outside1 }],
          },
        ],
        videoUrl: "https://www.youtube.com/shorts/LQAvF2QwTJU",
        title: "ЖК Старт",
        address: "Київ, ...",
        center: [50.4545, 30.4687],
        bearing: 0,
        buildingPolygon: [
          [50.45472, 30.4683],
          [50.45495, 30.46855],
          [50.45462, 30.46888],
          [50.45439, 30.46864],
        ],
        lichilHvp: "20.11.2031",
        lichilGvp: "02.03.2028",
        lichilWarm: "15.05.2030",
        tel: "tel:+380973934491",
        location: "https://maps.app.goo.gl/Mo73CUnrpnWvvo286",
        network:
          "https://www.olx.ua/d/obyavlenie/prodam-3k-kvartiru-v-kotsyubinskomu-vul-ponomarova-26-IDXlOJY.html",
      },
      {
        id: 113,
        rentsal: "Оренда",
        typeRealt: "Житло",
        kimnat: 3,
        vlasnik: "",
        // colorvlasnik:'0da514',
        name: "вулиця Хрещатик 15",
        foto: [
          hrechatik_1,
          hrechatik_2,
          hrechatik_3,
          hrechatik_4,
          hrechatik_5,
          hrechatik_11,
          hrechatik_12,
          hrechatik_6,
          hrechatik_7,
          hrechatik_8,
          hrechatik_9,
          hrechatik_10,
          hrechatik_13,
          hrechatik_14,
        ],

        photos: [
          {
            day:  hrechatik_1,
            evening:  hrechatik_14,
          },
          {
            day:  hrechatik_2,
            evening:  hrechatik_13,
          },
           {
            day:  hrechatik_3,
            evening:  hrechatik_12,
          },
            { day:  hrechatik_4, 
            evening:  hrechatik_11 
          },
           { day:  hrechatik_5, 
            evening:  hrechatik_5 
          },
             { day:  hrechatik_6, 
            evening:  hrechatik_6 
          },

        ],
        repair: "з ремонтом",
        interv: null,
        currency: "$",
        descrip: [
          "Квартира розташована на 4/5 пов, будинку, ліфт.Загальна пл - 76м2, одна спальня - 15 м, друга спальня - 8,4 м, вітальня-кухня - 26,1 м , сумісний сан вузол. Відкритий балкон у двір в Пассаж та закритий балкон у двір на Городецького. Газова плита, та газова колонка, 2 кондиціонери. Є всі необхідні меблі та техніка.Лічильники на : вода, електроенергія, газ",
        ],
        price: 1300,
        priceLast: 1300,
        priceGRN: "",
        priceLastGRN: "",

        flor: "4 з 5",
        area: 76,
        areaAll: "76 / 49 / 8",
        hight: "3.8 м",
        priceTime: 800,
        priceTimeGrn: 5000,
        florTime: 2,
        areaTime: 3,
        status: true,
        vip: false,

        avtoJivlenElevator: "Немає",
        avtoJivlenWather: "Є від міста",
        electricity: "8 кВт ",
        planImage: plan_hrechatik,
        markers: [
          {
            id: 1,
            title: "Ванна",
            x: 80,
            y: 25,
            media: [{ type: "video", src: hrechatik_marker1 }],
          },
          {
            id: 2,
            title: "Вітальня",
            x: 45,
            y: 25,
            media: [{ type: "video", src: hrechatik_marker2 }],
          },
          {
            id: 3,
            title: "Спальня 1",
            x: 30,
            y: 25,
            media: [{ type: "video", src: hrechatik_marker3 }],
          },
          {
            id: 4,
            title: "Спальня 2",
            x: 30,
            y: 60,
            media: [{ type: "video", src: hrechatik_marker4 }],
          },
          {
            id: 5,
            title: "Балкон 1",
            x: 20,
            y: 3,
            media: [{ type: "video", src: hrechatik_marker5 }],
          },
          {
            id: 6,
            title: "Балкон 2",
            x: 20,
            y: 83,
            media: [{ type: "image", src: hrechatik_marker6 }],
          },
        ],
        videoUrl: "https://www.youtube.com/shorts/LQAvF2QwTJU",
        title: "Хрещатик 15 (Пасаж)",
        address: "Київ, Хрещатик 15",
        center: [30.525516, 50.447539],
        bearing: 0,

        buildingPolygon: [
          [50.45472, 30.4683],
          [50.45495, 30.46855],
          [50.45462, 30.46888],
          [50.45439, 30.46864],
        ],

        fotoBild: [
          hrechatik_bild4,
          hrechatik_14,
          hrechatik_bild1,
          hrechatik_bild2,
          hrechatik_bild3,
        ],
        allApart: "102",
        allFlors: "5",
        typeBild: "дореволюційний",
        security: "Кодовий замок, Консьерж",
        material: "цегляна",
        heating: "централізоване опалення",
        yearBuild: "1917",
        houseWifi: "Volia, Kyivstar",
        shelter: "3 хв. пішки",
        water: "вода є",
        tax5: false,
        war5: false,
        mit1: false,
        pens1: false,
        nota: 100,
        komis: 25,

        // зима
        jek: 435,
        waterKom: "",
        abonVoda: 47.52,
        abonGv: 29.3,
        abonWarm: 42.44,
        warm: 1100,
        light: "",
        gas: '',
        internet: "",
        ohorona: 1000,
        other: 100,

        // літо
        jekSummer: 435,
        waterKomSummer: "",
        abonVodaSummer: 150,
        abonGvSummer: 45,
        abonWarmSummer: 35,
        warmSummer: 0,
        lightSummer: '',
        gasSummer: '',
        internetSummer: '',
        ohoronaSummer: 1000,
        otherSummer: 100,
        //лічильники
        lichilHvp: "20.07.2026",
        lichilGvp: "",
        lichilWarm: "",
         lichilGaz: "30.07.2029",

        tel: "tel:+380973934491",
        location: "https://maps.app.goo.gl/Mo73CUnrpnWvvo286",
        network:
          "https://www.olx.ua/d/obyavlenie/prodam-3k-kvartiru-v-kotsyubinskomu-vul-ponomarova-26-IDXlOJY.html",
      },
    ],
  },

  {
    id: 12,
    name: "Комерційна нерухомість",
    foto: commerce,
    lists: [
      {
        id: 123,
        typeRealt: "Комерція",
        rentsal: "Оренда",
        kimnat: "Open-Space",
        vlasnik: "0",

        name: "вулиця  Вільгельма Котарбінського 24 ЖК Старт",
        foto: [start_1, start_2],
          photos: [
          {
            day:  start_1,
            evening: '',
          },
          {
            day:  start_2,
            evening:  '',
          },
           {
            day:  hrechatik_3,
            evening:  '',
          },
            { day:  hrechatik_4, 
            evening:  '' 
          },
           { day:  hrechatik_5, 
            evening:  ''
          },
             { day:  hrechatik_6, 
            evening:  ''
          },

        ],
        repair: "без ремонту",
        interv: null,
        currency: "грн",
        descrip: [
          " Оренда фасадного приміщення з окремим входом по вул. Вільгельма Котарбінського 24 в сучасному ЖК \"СТАРТ\" Загальна пл - 99,5 м². Складаєтьсяз 2-х рівнів: 1 пов - 20,3 м² та 2 пов - 79,2 м². Характеристика приміщення: висота стелі 3,2м, вентканал, централізоване опалення (лічільник), потужність по електроенергії - 15 кВт з можливістю збільшення, радіатори з терморегулятором, індивідуальні лічильники на воду, пожежна сигналізація. Є місце для вивіски. Приміщення без ремонту. Ремонтні канікули обговорюються. Підходить під: кав'ярню, книгарню, пекарню, магазин продуктів, винний магазин і тд. Поруч: метро Лук'янівська 8 хвилин пішки, та багато нових житлових комплексів.Ціна - 0 грн/міс - перші 3 місяці (канікули). Ціна - 25 000 грн/міс - з 4-го місяця по 6-тий включно. Ціна - 45 000 грн /міс - з 6-го місяця по 12- тий включно. Ціна - 65 000 грн/міс - з 13-го місяця по 24 -тий включно",
        ],
        price: 568.18,
        priceLast: "",
        priceGRN: 25000,
        priceLastGRN: 45000,

        flor: "1 та 2 з 25",
        area: 99.5,
        areaAll: "99.5 м²",
        priceTime: 800,
        priceTimeGrn: 1000,
        florTime: 2,
        areaTime: 3,
        status: true,
        vip: false,

        avtoJivlenElevator: "не потрібно",
        avtoJivlenWather: "є від міста",
        electricity: "15 кВт з можливістю збільшення",
        planImage: plan_start,
        markers: [
          {
            id: 1,
            title: "Вхід",
            x: 14,
            y: 12,
            media: [{ type: "image", src: start_1 }],
          },
          {
            id: 2,
            title: "1-й поверх",
            x: 14,
            y: 33,
            media: [{ type: "video", src: marker_1et }],
          },
        ],
        videoUrl: "https://www.youtube.com/shorts/LQAvF2QwTJU",
        title: "Вільгельма Котарбінського 24 (ЖК Старт)",
        address: "Вільгельма Котарбінського 24, Київ",
        center: [30.481385, 50.457839],
        bearing: -70,

        buildingPolygon: [
          [50.45472, 30.4683],
          [50.45495, 30.46855],
          [50.45462, 30.46888],
          [50.45439, 30.46864],
        ],

        fotoBild: [bild_start_1, bild_start_2, bild_start_3, bild_start_4],
        hight: "3.2",
        allApart: "864",
        allFlors: "25",
        typeBild: "новобудова",
        security: "охорана, відеонагляд",
        material: "монолітно-каркасна, керамоблок",
        heating: "централізоване опалення",
        yearBuild: "2023",
        houseWifi: "Utels, Kyivstar, Коло",
        shelter: "2 хв. пішки, або паркінг",
        water: "вода є",

        tax5: false,
        war5: false,
        mit1: false,
        pens1: false,
        nota: 100,
        komis: 0,

        // зима
        jek: 435,
        waterKom: "",
        abonVoda: 47.52,
        abonGv: 29.3,
        abonWarm: 42.44,
        warm: '',
        light: "",
        gas: 0,
        internet: "",
        ohorona: 0,
        other: 150,

        // літо
        jekSummer: 435,
        waterKomSummer: "",
        abonVodaSummer: 150,
        abonGvSummer: 45,
        abonWarmSummer: 35,
        warmSummer: 0,
        lightSummer: '',
        gasSummer: 0,
        internetSummer: '',
        otherSummer: 120,
         ohoronaSummer: 0,
        //лічильники
        lichilHvp: "20.11.2028",
        lichilGvp: "",
        lichilWarm: "",
        viber: "380678928160",
        whatsapp:"380975259493",
        telegram: "Tomas2228",
        tel: "tel:+380973934491",
        location: "https://maps.app.goo.gl/Mo73CUnrpnWvvo286",
        network:
          "https://www.olx.ua/d/obyavlenie/prodam-3k-kvartiru-v-kotsyubinskomu-vul-ponomarova-26-IDXlOJY.html",
      },
    ],
  },
];

 const [apartAtatus, setApartAtatus] = useState([]);
    

     useEffect(() => {
      let interval;
  
      const getApartAtatus = async () => {
        try {
          const res = await fetch('https://69cad8baba5984c44bf3ee4a.mockapi.io/Apart/stats');
          if (!res.ok) {
            throw new Error('Failed to fetch restoran');
          }
          const data = await res.json();
          setApartAtatus(data);
        } catch (e) {
          console.error(e.message);
        }
      };
  
     
      getApartAtatus();


    }, []);
  

 return (
    <FsrContext.Provider value={{kategoris, apartAtatus }}>
      {children}
    </FsrContext.Provider>
  );



}

export default AppContext;


